<template>
  <v-dialog :value="isOpenDialogMessage" max-width="390" persistent>
    <v-card>
      <v-card-text class="pt-7 px-12 pb-0">
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <span style="color: #2661FF;" class="subtitle-2 font-weight-medium">
              <b>
                {{ $t("downloads.dialog2.title") }}
              </b>
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center pa-0">
            <v-icon color="warning">
              report_problem
            </v-icon>
          </v-col>
          <v-col cols="12">
            <v-divider class="orange darken-3" />
            <v-row>
              <v-col cols="12">
                <span class="orange--text darken-4">
                  {{ $t("downloads.dialog2.description") }}
                </span>
              </v-col>
            </v-row>
            <v-divider class="orange darken-3" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-4 pt-2">
        <v-row>
          <v-col cols="6" class="d-flex justify-end">
            <v-btn color="#2661FF" small @click="toDownloads()">
              <span style="color: white;">
                {{ $t("downloads.dialog2.button_to_downloads") }}
              </span>
            </v-btn>
          </v-col>
          <v-col cols="6" class="d-flex justify-start">
            <v-btn
              color="#2661FF"
              outlined
              small
              @click="close()"
              class="px-11"
            >
              {{ $t("downloads.dialog1.button_exit") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "DialogMessage",
  computed: {
    ...mapGetters({
      isOpenDialogMessage: "downloads/isOpenDialogMessage"
    })
  },
  methods: {
    ...mapMutations({
      toggleDialogMessage: "downloads/toggleDialogMessage"
    }),
    toDownloads() {
      this.$router.push("/downloads");
    },
    close() {
      this.toggleDialogMessage(false);
    }
  }
};
</script>
